<template>
  <main class="auth-shell q-pa-lg">
    <q-card :class="['auth-shell-card lg-radius', { 'auth-shell-card-wide': wide }]">
      <div class="floating-icons">
        <q-img
          src="/assets/icon/chip.png"
          class="floating-icon floating-chip"
          fit="contain"
          aria-hidden="true"
        />
        <q-img
          src="/assets/icon/shield.png"
          class="floating-icon floating-shield"
          fit="contain"
          aria-hidden="true"
        />
      </div>

      <!-- Panels render one or two root sections, so the shell cannot put the
           grow/centering classes on the slotted content itself. This region
           absorbs the card's spare height, which keeps the footer at the bottom. -->
      <div class="column col-grow justify-center">
        <slot />
      </div>

      <q-card-section class="auth-shell-footer column items-center border-top q-pt-xs q-pb-sm">
        <q-img
          :src="LOGO.FULL"
          fit="contain"
          class="auth-shell-footer-logo"
          alt="Cookie Armor"
        />
      </q-card-section>
    </q-card>
  </main>
</template>

<script setup>
  import { LOGO } from 'src/services/consts/app.const'

  defineProps({
    wide: {
      type: Boolean,
      default: false,
    },
  })
</script>

<style lang="scss">
  .auth-shell {
    display: grid;
    place-items: center;
    min-height: 100vh;
    background: linear-gradient(
      135deg,
      rgba($brand-light, 0.5) 0%,
      #ffffff 5%,
      rgba($primary-dark, 0.08) 35%,
      rgba($brand, 0.12) 50%,
      rgba($primary, 0.08) 65%,
      #ffffff 90%,
      rgba($brand-light, 0.5) 100%
    );

    .auth-shell-card {
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 10;
      width: 90%;
      max-width: 27rem;
      min-height: 30rem;
      background: rgba(255, 255, 255, 0.85);
      animation: cardEnter 0.5s ease-out;
      overflow: visible;
      box-shadow: $card-shadow;
      border: 1px solid $border;
    }

    .auth-shell-card-wide {
      max-width: 48rem;
      max-height: calc(100vh - 4rem);
    }

    // Shared brand footer for every panel rendered into the slot, so the gate and
    // the invite landing are all identifiable.
    .auth-shell-footer {
      flex-shrink: 0;
      border-color: $border;

      .auth-shell-footer-logo {
        width: 10rem;
        height: auto;
      }
    }

    .floating-icons {
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: 1;
    }

    .floating-icon {
      position: absolute;
      width: 7.8125rem;
      height: 7.8125rem;
      opacity: 0;
    }

    .floating-chip {
      top: -6.875rem;
      left: -7.5rem;
      animation:
        fadeIn 0.5s ease-out forwards,
        float1 5s ease-in-out 1.3s infinite;
    }

    .floating-shield {
      bottom: -5rem;
      right: -8.75rem;
      animation:
        fadeIn 0.5s ease-out forwards,
        float2 8s ease-in-out 1.6s infinite;
    }

    // Decorative icons keep their post-fadeIn resting state; only the endless
    // float is dropped, since .floating-icon starts at opacity 0.
    @media (prefers-reduced-motion: reduce) {
      .floating-chip,
      .floating-shield {
        animation: none;
        opacity: 1;
        transform: none;
      }
    }
  }
</style>
